import React, { useEffect, useState } from "react";

const VerifyKycPopup = ({
    isOpen,
    onClose,
    onSubmit,
    kycData,
    subscriberId,
}) => {
    const [kycFormData, setKycFormData] = useState({
        name_verify: kycData?.name_verified || "",
        dob_verify: kycData?.dob_verified || "",
        pan_verify: kycData?.pan_verified || "",
        aadhar_verify: kycData?.aadhar_verified || "",
    });

    const verifyList = ["Pending", "Approved", "Rejected"];

    // Set initial values based on API data when kycData changes
    useEffect(() => {
        if (kycData) {
            setKycFormData({
                name_verify: kycData.name_verified || 0,
                dob_verify: kycData.dob_verified || 0,
                pan_verify: kycData.pan_verified || 0,
                aadhar_verify: kycData.aadhar_verified || 0,
            });
        }
    }, [kycData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setKycFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const payload = {
            name_verify: parseInt(kycFormData.name_verify),
            dob_verify: parseInt(kycFormData.dob_verify),
            pan_verify: parseInt(kycFormData.pan_verify),
            aadhar_verify: parseInt(kycFormData.aadhar_verify),
            kycid: parseInt(kycData?.id),
            subid: parseInt(subscriberId)
        }
        onSubmit(payload);
        setKycFormData({
            name_verify: kycData.name_verified || 0,
            dob_verify: kycData.dob_verified || 0,
            pan_verify: kycData.pan_verified || 0,
            aadhar_verify: kycData.aadhar_verified || 0,
        });
    };
    if (!isOpen) return;
    return (
        <div
            id="verifykycmodal"
            className="modal fade show"
            style={{ display: "block" }}
        >
            <div className="modal-dialog modal-md">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="col-md-6">
                            <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                                Verify KYC Details
                            </h5>
                        </div>
                        <div className="col-md-6">
                            <button
                                type="button"
                                className="btn btn-default float-end"
                                onClick={onClose}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="panel-body">
                                <div className="row">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Details</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Name Details</td>
                                                <td>
                                                    <select
                                                        name="name_verify"
                                                        className="form-control"
                                                        value={kycFormData.name_verify}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        {verifyList.map((option, index) => (
                                                            <option key={index} value={index}>{option}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Date of Birth Details</td>
                                                <td>
                                                    <select
                                                        name="dob_verify"
                                                        className="form-control"
                                                        value={kycFormData.dob_verify}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        {verifyList.map((option, index) => (
                                                            <option key={index} value={index}>{option}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Pan Details</td>
                                                <td>
                                                    <select
                                                        name="pan_verify"
                                                        className="form-control"
                                                        value={kycFormData.pan_verify}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        {verifyList.map((option, index) => (
                                                            <option key={index} value={index}>{option}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr>
                                            {/* <tr>
                                                <td>Aadhar Details</td>
                                                <td>
                                                    <select
                                                        name="aadhar_verify"
                                                        className="form-control"
                                                        value={kycFormData.aadhar_verify}
                                                        onChange={handleChange}
                                                        required
                                                    >
                                                        {verifyList.map((option, index) => (
                                                            <option key={index} value={index}>{option}</option>
                                                        ))}
                                                    </select>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="" style={{ textAlign: "right" }}>
                                    <button
                                        type="submit"
                                        name="submit"
                                        className="btn btn-primary btn-sm"
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        name="cancel"
                                        className="btn btn-default btn-sm"
                                        onClick={onClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyKycPopup;
